export function accordion() {
    let $accordionItems = $(".accordion-item");

    $(".accordion button").append('<i><svg width="16" height="9" viewBox="0 0 16 9" fill="none">\n' +
        '  <path d="M15 0.5L8 7.5L1 0.5" stroke="#553A68"/>\n' +
        '</svg></i>')
    $(".accordion-columns-holder").on("click", "button", function () {
        let parent = $(this).parents(".accordion-item");

        if (parent.hasClass("active")) {
            parent.removeClass("active").find(".accordion-info").slideUp(350);
        } else {
            $accordionItems.removeClass("active").find(".accordion-info").slideUp(350)
            parent.addClass("active").find(".accordion-info").slideDown(350);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js